module.exports = __webpack_public_path__ + "static/media/2.c4945f2d.png";